var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKerasImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 55H53V120H118V55ZM75.8841 68.975L76.4244 69.43V86.3361L93.9236 68.8694H99.2353L99.7756 69.948L85.8534 83.7645L100.675 105.261L100.125 106.076H94.8783L82.2784 87.4452L76.4284 93.0737V105.535L75.9206 106.076H71.9638L71.4234 105.535V69.428L71.8784 68.973L75.8841 68.975Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(53 55)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKerasImg);
export default __webpack_public_path__ + "static/media/KerasImg.f3af4f4625603515fd1ff255a0fda1aa.svg";
export { ForwardRef as ReactComponent };